<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container">
    <leader-data :agency-code="agencyCode" />
  </div>
</template>

<script>
export default {
  name: 'TourLeader',
  components: {
    leaderData: () => import('@/views/ita/components/leaderData.vue'),
  },
  data() {
    return {
      list: null,
      agencyCode: null,
    }
  },
  created() {
    this.agencyCode = this.$store.getters.userInfo.agencyCode
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>
